export default "__VITE_ASSET__DE4Ijw_V__"